import { render } from "./SidePanelDivider.vue?vue&type=template&id=39d8e15e&scoped=true"
const script = {}

import "./SidePanelDivider.vue?vue&type=style&index=0&id=39d8e15e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d8e15e"]])

export default __exports__